import React from 'react';
import { AlertCircleIcon, XCircleIcon } from 'lucide-react';
export function PainPoints() {
  const symptoms = ['Barriga globo en la tarde aunque comas poco', 'Ropa que te aprieta conforme pasa el día', 'Retención de líquidos y sensación de pesadez', 'Cansancio constante y falta de energía', 'Antojos nocturnos incontrolables'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-156">
      <div className="container mx-auto px-4" data-id="element-157">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-159">
            ¿Te pasa esto?
          </h2>
          <p className="text-lg text-stone-600" data-id="element-160">
            No es falta de voluntad. Es tu cuerpo pidiendo una pausa.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto" data-id="element-161">
          <div className="bg-stone-50 rounded-2xl p-8 md:p-10" data-id="element-162">
            <ul className="space-y-6" data-id="element-163">
              {symptoms.map((symptom, index) => <li key={index} className="flex items-start" data-id="element-164">
                  <XCircleIcon className="h-6 w-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-165" />
                  <span className="text-lg text-stone-700 font-medium" data-id="element-166">
                    {symptom}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col justify-center items-center text-center p-8 bg-emerald-50 rounded-2xl h-full border border-emerald-100" data-id="element-167">
            <AlertCircleIcon className="h-12 w-12 text-emerald-600 mb-6" data-id="element-168" />
            <h3 className="text-2xl font-bold text-stone-900 mb-4" data-id="element-169">
              La realidad diaria
            </h3>
            <p className="text-xl text-stone-600 italic" data-id="element-170">
              "De día intento cuidarme, pero de noche me rindo ante la ansiedad
              y la hinchazón."
            </p>
          </div>
        </div>
      </div>
    </section>;
}